import Label from './AvatarLabel.styles';

interface AvatarLabelProps {
  name: string;
  left: number;
  top: number;
}

export const AvatarLabel = ({ name, left, top }: AvatarLabelProps) => (
  <Label $left={left} $top={top}>
    {name}
  </Label>
);
